import type { UseInfiniteQueryResult } from '@tanstack/react-query';

export const scrollUtils = {
  onScrollToBottom: (event: React.UIEvent | Event, handleOnBottomReached: () => void) => {
    const node = event.currentTarget as HTMLElement;
    const isBottomReached = node.scrollTop + node.clientHeight >= 0.9 * node.scrollHeight;

    if (isBottomReached) handleOnBottomReached();
  },
  triggerFetchNextPageOnScrollToBottom: <TData>(query: UseInfiniteQueryResult<TData, unknown>) => {
    const { hasNextPage, isFetchingNextPage, fetchNextPage } = query;

    const handleBottomIsReachedOnScroll = () => {
      if (hasNextPage && !isFetchingNextPage) fetchNextPage();
    };

    return (event: React.UIEvent | Event) =>
      scrollUtils.onScrollToBottom(event, handleBottomIsReachedOnScroll);
  },
};
